import { LinkButton } from '@/atoms/Button/LinkButton'
import { FlexColumn } from '@/atoms/FlexContainers'
import { VideoCheckOutlineIcon } from '@/atoms/Icons/VideoCheckOutlineIcon'
import { InternalLink } from '@/atoms/InternalLink'
import { HeadingLG, HeadingSM, ParagraphSM } from '@/atoms/Text'
import { paths } from '@/constants/paths'
import { useSafeTrack } from '@/utils/analytics/safe-analytics'
import { Translate, useTranslate } from '@/utils/translate/translate-client'
import { Label } from '@/views/GuildCreateView/components/Inputs'

export const SubmitSection = () => {
  const { t } = useTranslate('about')
  const track = useSafeTrack()

  const handleClick = () => {
    track('About Page Submit Project Button Clicked')
  }

  return (
    <section className="py-[72px]" id="submit">
      <FlexColumn className="mx-auto gap-8 px-8 md:w-[693px] md:px-0 xl:w-fit xl:max-w-[1242px]">
        <FlexColumn className="gap-6">
          <VideoCheckOutlineIcon size={48} />
          <HeadingLG weight="bold">
            {t('submittingProjectToAngelStudios', 'Submitting a Project to Angel Studios')}
          </HeadingLG>
          <Translate t={t} i18nKey="submittingProjectBlurb">
            <ParagraphSM>
              Are you a filmmaker that has the perfect project that amplifies light? We make it easy for creators to{' '}
              <InternalLink className="underline" href={paths.filmmakers.index}>
                submit your projects
              </InternalLink>{' '}
              to us. We’re looking for Torches that are true, honest, noble, just, authentic, admirable, lovely, and
              excellent. If your project meets these requirements, then follow these steps to submit.
            </ParagraphSM>
          </Translate>
        </FlexColumn>
        <div className="grid grid-cols-1 gap-x-16 gap-y-8 lg:grid-cols-2">
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('fillOutApplicationStep', '1. Fill out the application form')}</HeadingSM>
            <Translate t={t} i18nKey="applicationStepBlurb">
              <ParagraphSM>
                You’ll provide information about the project, the current stage of production, include a video file,
                sign the agreement, and include your application fee.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('passAngelGuildStep', '2. Pass the Angel Guild')}</HeadingSM>
            <Translate t={t} i18nKey="guildStepBlurb">
              <ParagraphSM>
                The Guild will review and decide if it meets their requirements and vote on the projects.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('buildMovementStep', '3. Build the movement')}</HeadingSM>
            <Translate t={t} i18nKey="movementStepBlurb">
              <ParagraphSM>Start growing the audience for your production.</ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('crowdfundStep', '4. Crowdfund')}</HeadingSM>
            <Translate t={t} i18nKey="crowdfundStepBlurb">
              <ParagraphSM>
                We’ll work with Angel Funding to start raising the capital to fund the production.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('productionStop', '5. Production')}</HeadingSM>
            <Translate t={t} i18nKey="productionStepBlurb">
              <ParagraphSM>
                If your project isn’t finished, this is where we let you bring your vision to life. If you’ve already
                finished production, then this step can be skipped.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
          <FlexColumn className="gap-4">
            <HeadingSM weight="semibold">{t('distributionStep', '6. Distribution')}</HeadingSM>
            <Translate t={t} i18nKey="distributionStepBlurb">
              <ParagraphSM>
                The final step, we’ll work with you to create a distribution strategy to reach a wide audience.
              </ParagraphSM>
            </Translate>
          </FlexColumn>
        </div>
        <LinkButton className="h-14 lg:w-1/3" href={paths.filmmakers.index} onClick={handleClick} variant="white">
          <Label>{t('submitYourProject', 'Submit Your Project')}</Label>
        </LinkButton>
      </FlexColumn>
    </section>
  )
}
